module.exports = __webpack_public_path__ + "static/media/ibn-battuta.d53c3f75.jpeg";